import service from "./service"

const preCheckDoNotAgree = async (data) => {
    return service(data)
}

export default preCheckDoNotAgree
